module.exports = __webpack_public_path__ + "static/media/coachtracker-menu-item.cfdf1719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coachtracker-menu-item.svg
// module id = 173
// module chunks = 0